module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-moreFunction"
  }, [_c('div', {
    staticClass: "hdfix"
  }, [_c('mt-header', [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [(!_vm.status) ? _c('router-link', {
    attrs: {
      "to": "/opera/"
    }
  }, [_c('i', {
    staticClass: "mintui mintui-back"
  })]) : _vm._e(), _vm._v(" "), _c('mt-button', {
    staticClass: "left",
    class: {
      active: _vm.status
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.status ? _vm.$t('cancel') : _vm.$t('myApp')))]), _vm._v(" "), (_vm.status) ? _c('span', {
    staticClass: "tip"
  }, [_vm._v("（" + _vm._s(_vm.$t('moreFunction_tip')) + "）")]) : _vm._e()], 1), _vm._v(" "), _c('mt-button', {
    staticClass: "right",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.setList
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.status ? _vm.$t('complete') : _vm.$t('edit')) + "\n        ")])], 1)], 1), _vm._v(" "), _c('my-list', {
    attrs: {
      "isEdit": _vm.status
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2f2ad9a2","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/moreFunction.vue
// module id = 1761
// module chunks = 107